import React from 'react';

import { MaskedSensitiveField, defaultMaskFn } from './MaskedSensitiveField';

import { TableColumn } from 'components/Table/types';

import { formatDateTimeWithTimezone } from 'utils/app';

import { APIBank } from 'types/api';

export const bankColumns = (
  canReveal: boolean,
  timezoneValue: string,
): TableColumn<APIBank>[] => [
  {
    dataId: 'id',
    label: 'id',
    minWidth: 80,
    width: 140,
    hidden: true,
    sortable: true,
    resizable: true,
    filterType: 'string',
  },
  {
    dataId: 'routing',
    label: 'bankList.column.routing',
    minWidth: 80,
    width: 160,
    hidden: false,
    sortable: true,
    resizable: true,
    filterType: 'string',
    formatter: (value: string) => ({
      value: defaultMaskFn(value),
      element: <MaskedSensitiveField value={value} canReveal={canReveal} />,
    }),
  },
  {
    dataId: 'account',
    label: 'bankList.column.account',
    minWidth: 80,
    width: 160,
    hidden: false,
    sortable: true,
    resizable: true,
    filterType: 'string',
    formatter: (value: string) => ({
      value: defaultMaskFn(value),
      element: <MaskedSensitiveField value={value} canReveal={canReveal} />,
    }),
  },
  {
    dataId: 'accountName',
    label: 'bankList.column.accountName',
    minWidth: 80,
    width: 200,
    hidden: false,
    sortable: true,
    resizable: true,
    filterType: 'string',
  },
  {
    dataId: 'bankName',
    label: 'bankList.column.bankName',
    minWidth: 80,
    width: 100,
    hidden: false,
    sortable: true,
    resizable: true,
    filterType: 'string',
  },
  {
    dataId: 'companyName',
    label: 'bankList.column.companyName',
    minWidth: 80,
    width: 130,
    hidden: false,
    sortable: true,
    resizable: true,
    filterType: 'string',
  },
  {
    dataId: 'address',
    label: 'bankList.column.address',
    minWidth: 80,
    width: 130,
    hidden: false,
    sortable: true,
    resizable: true,
    filterType: 'string',
  },
  {
    dataId: 'city',
    label: 'bankList.column.city',
    minWidth: 80,
    width: 130,
    hidden: false,
    sortable: true,
    resizable: true,
    filterType: 'string',
  },
  {
    dataId: 'state',
    label: 'bankList.column.state',
    minWidth: 80,
    width: 100,
    hidden: false,
    sortable: true,
    resizable: true,
    filterType: 'string',
  },
  {
    dataId: 'zip',
    label: 'bankList.column.zip',
    minWidth: 80,
    width: 100,
    hidden: false,
    sortable: true,
    resizable: true,
    filterType: 'string',
  },
  {
    dataId: 'createdOn',
    label: 'bankList.column.createdOn',
    minWidth: 80,
    width: 180,
    hidden: false,
    sortable: true,
    resizable: true,
    filterType: 'date',
    formatter: value => ({
      value: formatDateTimeWithTimezone(value as string, timezoneValue),
    }),
  },
  {
    dataId: 'updatedOn',
    label: 'bankList.column.updatedOn',
    minWidth: 80,
    width: 180,
    hidden: false,
    sortable: true,
    resizable: true,
    filterType: 'date',
    formatter: value => ({
      value: formatDateTimeWithTimezone(value as string, timezoneValue),
    }),
  },
];
